import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MessageSquare, Calendar, Clock, User, Bell, ChevronDown, ChevronUp, Loader, Home, } from "lucide-react";
import "../Style/Notification.css";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";

const formatDate = (dateString) =>
  dateString
    ? new Date(dateString).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    : "";

const formatTime = (dateString) =>
  dateString
    ? new Date(dateString).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    : "";

const NoticeItem = ({ item, onOpen }) => {
  const navigate = useNavigate();


  const member = item.memberName || "Unknown Member";
  const title = item.title || "Chat";
  const date = item.date || null;
  const flatNo = item.unitNo || "—";

  const handleClick = () => {
    onOpen();
    navigate(
      `/chat-page/${encodeURIComponent(member)}/${encodeURIComponent(
        title
      )}/${encodeURIComponent(flatNo)}`
    );
  };

  return (
    <div
      className={`notice-item-modern ${item.highlight ? "notice-highlight" : ""
        }`}
      onClick={handleClick}
    >
      <div className="notice-icon-bubble">
        <MessageSquare size={18} />
      </div>

      <div className="notice-body">
        <div className="notice-top">
          <h4 className="notice-subject">{title}</h4>

          <span className="notice-unit-badge">
            <Home size={12} />
            <span>{flatNo}</span>
          </span>
{item.count > 0 ? (
  <span className="notice-count-badge red">
    {item.count}
  </span>
) : (
  <span className="seen-badge green">
    ✓ Seen
  </span>
)}
        </div>

        <div className="notice-member">
          <User size={12} />
          <span>{member}</span>
        </div>

        <div className="notice-timestamp">
          <div className="timestamp-item">
            <Calendar size={11} />
            <span>{formatDate(date)}</span>
          </div>
          <div className="timestamp-item">
            <Clock size={11} />
            <span>{formatTime(date)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function CircularNotice() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [activeChat, setActiveChat] = useState(null);
  const [filterType, setFilterType] = useState("ALL");
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [showFilterScreen, setShowFilterScreen] = useState(false);

  // FETCH DATA
  useEffect(() => {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");
    fetchData("All");
  }, []);
  const fetchData = async (type) => {
    try {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      const res = await fetch(
        `${BASE_URL}/chat/get-all-chat?societyName=${encodeURIComponent(
          societyName
        )}&type=${encodeURIComponent(type)}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to fetch notices");

      const json = await res.json();

      const normalized = (json || []).map((it) => ({
        ...it,
        memberName: it.memberName || it.member_name || "",
        title: (it.title || it.subject || "Chat").trim(),
        date: it.date || it.timestamp || null,
        message: it.message || it.msg || "",
        unitNo: (it.unitNo || it.unit_no || "").trim(),
      }));

      // const grouped = {};

      // normalized.forEach((it) => {
      //   const key = `${it.title.toUpperCase()}||${it.unitNo.toUpperCase()}`;

      //   if (!grouped[key]) {
      //     grouped[key] = {
      //       ...it,
      //       count: 0,
      //     };
      //   } else {
      //     grouped[key].count = 0;
      //     if (new Date(it.date) > new Date(grouped[key].date)) {
      //       grouped[key].date = it.date;
      //     }
      //   }
      // });
  const grouped = {};

normalized.forEach((it) => {
  const key = `${it.title.toUpperCase()}||${it.unitNo.toUpperCase()}`;

  if (!grouped[key]) {
    grouped[key] = {
      ...it,
      count: it.seen === false ? 1 : 0,
      seen: it.seen,
    };
  } else {
    if (it.seen === false) {
      grouped[key].count += 1;
      grouped[key].seen = false;
    }

    if (new Date(it.date) > new Date(grouped[key].date)) {
      grouped[key].date = it.date;
    }
  }
});

      setNotices(Object.values(grouped));
    } catch (error) {
      toast.error("Unable to load notices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const socket = new SockJS(`${BASE_URL}/ws-chat`);

    const client = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
    });

    client.onConnect = () => {
      console.log("STOMP Connected");

      // ✅ SUBSCRIBE MUST BE INSIDE THIS
      client.subscribe("/topic/notifications", (message) => {
        const data = JSON.parse(message.body);

        console.log("WS DATA:", data);

        const unitNo = data.unitNo || data.flatNo;
        const title = data.title;

        if (!unitNo || !title) return;

        setNotices((prev) => {
          const exists = prev.find(
            (item) =>
              item.unitNo?.toUpperCase() === unitNo.toUpperCase() &&
              item.title?.toUpperCase() === title.toUpperCase()
          );

          if (exists) {
            return prev.map((item) =>
              item.unitNo?.toUpperCase() === unitNo.toUpperCase() &&
                item.title?.toUpperCase() === title.toUpperCase()
                ? {
                  ...item,
                  count:
                    activeChat &&
                      activeChat.unitNo === unitNo &&
                      activeChat.title === title
                      ? 0
                      : (item.count || 0) + 1,
                  date: new Date().toISOString(),
                  // highlight: true,
                  highlight:
  !(
    activeChat &&
    activeChat.unitNo === unitNo &&
    activeChat.title === title
  ),
                }
                : item
            );
          } else {
            return [
              {
                ...data,
                unitNo: unitNo,
                count: 1,
                highlight: true,
              },
              ...prev,
            ];
          }
        });

        // remove highlight
        setTimeout(() => {
          setNotices((prev) =>
            prev.map((item) =>
              item.unitNo?.toUpperCase() === unitNo.toUpperCase() &&
                item.title?.toUpperCase() === title.toUpperCase()
                ? { ...item, highlight: false }
                : item
            )
          );
        }, 3000);
      });
    };

    client.activate();

    return () => {
      if (client.active) {
        client.deactivate();
      }
    };
  }, [activeChat]);

  const visibleNotices = showAll ? notices : notices.slice(0, 5);
  return (

    <div className="notice-card-modern">
      <div className="notice-filter-bar wrap-filter">
        {[
          "ALL",
          "PASSPORT NOC",
          "RENOVATION NOC",
          "GAS NOC",
        ].map((type) => (
          <button
            style={{ color: "#007BFF" }}
            key={type}
            className={`filter-btn ${filterType === type ? "active" : ""}`}
            // onClick={() => fetchData(type)}
            onClick={() => {
  setFilterType(type);
  fetchData(type);
}}
          >
            {type}
          </button>
        ))}

        {showMoreFilters &&
          [
            "SALES NOC",
            "GATE PASS",
            "LOAD NOC",
            "OTHER",
            "UNREAD",
            "READ",
          ].map((type) => (
            <button
              style={{ color: "#007BFF" }}
              key={type}
              className={`filter-btn ${filterType === type ? "active" : ""}`}
              onClick={() => {
                setFilterType(type);
                fetchData(type);
              }}
            >
              {type}
            </button>
          ))}

        <button
          className="filter-btn more-btn"
          onClick={() => setShowMoreFilters(!showMoreFilters)}
        >
          {showMoreFilters ? "Less ▲" : "More ▼"}
        </button>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="notice-card-header">

        <div className="notice-header-icon">
          <Bell size={18} />
        </div>
        <h3 style={{ color: "#007BFF" }}>Recent NOC</h3>
      </div>

      <div className="notice-card-body">

        {loading ? (
          <div className="notice-loading-state">
            <Loader size={28} className="spinner" />
            <p>Loading messages...</p>
          </div>
        ) : notices.length === 0 ? (
          <div className="notice-empty-state">
            <MessageSquare size={48} />
            <p>No messages found</p>
          </div>
        ) : (
          <>
            <div className="notice-list"  >
              {visibleNotices.map((n, i) => (
                <NoticeItem

                  key={`${n.memberName}-${n.title}-${i}`}
                  item={n}
                  onOpen={() => {
                    setActiveChat({
                      unitNo: n.unitNo,
                      title: n.title,
                    });

                    setNotices((prev) =>
                      prev.map((item) =>
                        item.unitNo === n.unitNo &&
                          item.title === n.title
                       ? { ...item, count: 0, seen: true, highlight: false }
                          : item
                      )
                    );
                  }}
                />
              ))}
            </div>

            {notices.length > 5 && (
              <button
                className="notice-show-more-btn"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? (
                  <>
                    <span>Show Less</span>
                    <ChevronUp size={16} />
                  </>
                ) : (
                  <>
                    <span>
                      Show More ({notices.length - 5} more)
                    </span>
                    <ChevronDown size={16} />
                  </>
                )}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
